var b1 = "/static/1766b5de35b15718.png";

export { b1 as default };
//# sourceMappingURL=b_1.png.js.map
